import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('applicationSelectPanelField');

    return {
        NO_APPLICATIONS_FOUND: t('noApplicationsFound'),
        SEARCH: t('search')
    };
};

export default useTranslation;
